import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import './App.css';
import { UserProvider } from './context/UserContext';

import Root from './components/Root';
import Landing from './Pages/Landing';
import Products from './Pages/Products';
import ProductPage from './Pages/ProductPage';
import AdminLogin from './novellum/AdminLogin';
import AdminDash from './novellum/AdminDash'
import Company from './Pages/Company';
import Contact from './Pages/Contact';
import CartCheckout from './Pages/CartCheckout';
import OrderConfirmed from './Pages/OrderConfirmed';



const router = createBrowserRouter( createRoutesFromElements (
  <Route path='/' element={ <Root/>} >
    <Route index element={ <Landing/> } />
    <Route path='products' element={ <Products/> } />
    <Route path='productpage/:id' element={ <ProductPage/> } />
    <Route path='company' element={ <Company/> } />
    <Route path='contact' element={ <Contact/> }/>
    <Route path='checkout' element={ <CartCheckout/> } />
    <Route path='confirmation' element={ <OrderConfirmed/> } />
    <Route path='admin' element={ <AdminLogin/> } />
    <Route path='admin/dashboard' element={ <AdminDash/> } /> 
  </Route>
));

function App () {
  return(
    <div>
      <UserProvider>
          <RouterProvider router={router} />
      </UserProvider>
      
    </div>
  );
}

export default App;
